import convertPropNames from './caseConverter'

export interface GoodResponse<T> {
  isOk: true
  data: T
}

export interface FailedResponse<T, K> {
  isOk: false
  type: T
  data: K
}

export const parseGoodResponse = <T>(
  data?: any,
): GoodResponse<T> => ({
    isOk: true,
    data: convertPropNames<T>(data),
  })

export const parseFailedResponse = <
  T,
  L
>(
    type: T,
    data: L,
  ): FailedResponse<T, L> => ({
    isOk: false,
    data: convertPropNames<L>(data),
    type,
  })
